<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addAdmin">新增</el-button> -->
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="handleSolve">解除禁用</el-button>
	        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleForbid">禁用账户</el-button> -->
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%"
		 :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
			<el-table-column label="会员折扣规则" width="500">
				<template v-slot="scope">
					<el-table :data="scope.row.vip_grade_all">
						<el-table-column label="会员等级" prop="vip_name"></el-table-column>
						<el-table-column prop="upMoney" label="达成条件"></el-table-column>
						<el-table-column prop="reduceMoney" label="享受优惠(店内不打折)"></el-table-column>
						<el-table-column label="享受优惠(店内打折)">
							<template v-slot="scope">
								<span>{{scope.row.point_times}}倍积分</span>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</el-table-column>
			<el-table-column prop="start_time" label="开始时间"></el-table-column>
			<el-table-column prop="end_time" label="结束时间"></el-table-column>
			<el-table-column label="状态">
				<template v-slot="scope">
					<el-tag type="success" v-if="scope.row.status==1">开启</el-tag>
					<el-tag type="danger" v-if="scope.row.status==2">关闭</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="230">
				<template #default="scope">
					<el-button v-if="scope.row.status==2" type="success" size="mini" @click="statusChange(scope.row)">开启</el-button>
					<el-button v-if="scope.row.status==1" type="danger" size="mini" @click="statusChange(scope.row)">关闭</el-button>
					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
					<el-button v-if="this.localGet('userId')==1" type="warning" size="mini" @click="del(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--总数超过一页，再展示分页器-->
		<!-- <el-pagination
	      background
	      layout="prev, pager, next"
	      :total="total"
	      :page-size="pageSize"
	      :current-page="currentPage"
	      @current-change="changePage"
	    /> -->
	</el-card>
	<el-dialog title="会员等级详情设置" v-model="dialogFormVisible">
		<el-button :disabled="addDisabled" type="primary" v-show="ishowAddButton" @click="AddForm" style="margin-top: -5em;position: absolute;margin-left: 11em">添加</el-button>
		<el-button type="primary" :disabled="delDisabled" v-show="ishowDelButton" @click="DeleteForm" style="margin-top: -5em;position: absolute;margin-left: 18em">删除</el-button>
		<el-form :model="form" ref="form" :rules="rules">
			<el-form-item v-for="(item,index) in form.items" :key="index">
				<label style="color: red">区间{{index+1}}</label>
				<el-form-item>
					<el-row :gutter="20">
						<el-col :span="2">
							<label>订单价格</label>
						</el-col>
						<el-col :span="10">
							<el-form-item :prop="'items.' + index + '.upMoney'" :rules="rules.upMoney">
								<el-input v-model="item.upMoney" placeholder="订单总价格" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item>
					<el-row :gutter="20">
						<el-col :span="2">
							<label>优惠价格</label>
						</el-col>
						<el-col :span="10">
							<el-form-item :prop="'items.' + index + '.reduceMoney'" :rules="rules.reduceMoney">
								<el-input v-model="item.reduceMoney" placeholder="店内不打折,每单优惠价格" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item>
					<el-row :gutter="20">
						<el-col :span="2">
							<label>积分返还</label>
						</el-col>
						<el-col :span="10">
							<el-form-item :prop="'items.' + index + '.point_times'" :rules="rules.point_times">
								<el-input v-model="item.point_times" placeholder="店内打折,每单返还积分" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item>
					<el-row :gutter="20">
						<el-col :span="2">
							<label>会员等级</label>
						</el-col>
						<el-col :span="10">
							<el-form-item :rules="rules.customer_grade_id" :prop="'items.' + index + '.id'">
								<el-select v-model="item.id" placeholder="请选择" clearable>
									<el-option v-for="item in options" :key="item.vip_name" :label="item.vip_name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<div style="border-bottom: 1px solid #dcdfe6"></div>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="2">
						<label>开始时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.start_time" prop="start_time">
							<el-input v-model="form.start_time" type="date" placeholder="开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="2">
						<label>结束时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.end_time" prop="end_time">
							<el-input v-model="form.end_time" type="date" placeholder="结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'VipGradeSet',
		data() {
			return {
				list: [],
				loading: false,
				multipleSelection: [],
				options: [],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				ishowAddButton: true,
				ishowDelButton: true,
				addDisabled: false,
				delDisabled: false,
				btnDisabled: true,

				form: {
					start_time: '',
					end_time: '',
					items: [],
				},
				rules: {
					upMoney: [{
						required: true,
						message: '请填写价格',
						trigger: 'blur'
					}, {
						min: 3,
						message: '请设置金额在一百以上',
						trigger: 'blur'
					}],
					reduceMoney: [{
						required: true,
						message: '请填写优惠价格',
						trigger: 'blur'
					}],
					point_times: [{
						required: true,
						message: '请填写返还积分',
						trigger: 'blur'
					}],
					customer_grade_id: [{
						required: true,
						message: '请选择类别',
						trigger: 'change'
					}],
					start_time: [{
						required: true,
						message: '请选择时间',
						trigger: 'blur'
					}],
					end_time: [{
						required: true,
						message: '请选择时间',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			getVipGradeList() {
				this.loading = true
				this.httpPost({
					url: '/admin/vipgrade/vip_grade_list',
					data:{
						routePath: this.$route.path
					}
				}).then((res) => {
					this.list = res.data;
					for (let i in this.list) {
						this.list[i].start_time = this.timestampToTime(this.list[i].start_time);
						this.list[i].end_time = this.timestampToTime(this.list[i].end_time);
					}
					this.loading = false;
				})
			},
			del(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/vipgrade/del",
				  {id:id}).then((res) => {
				  // console.log(data);
							
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.getVipGradeList();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			edit(val) {
				this.getVipGradeAll();
				if (val) {
					this.form.items = val.vip_grade_all;
					this.form.id = val.id;
					this.form.start_time = val.start_time;
					this.form.end_time = val.end_time;
				} else {
					this.resetObj(this.form)
				}

				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			getVipGradeAll() {
				this.httpPost({
					url: '/admin/vipgrade/get_vip_grade_all',
				}).then((res) => {
					this.options = res.data;
				})
			},
			AddForm() {
				this.btnDisabled = false;
				this.form.items.push({});
			},
			DeleteForm() {
				this.form.items.pop();
				if (this.form.items.length == 0) {
					this.btnDisabled = true;
				}
			},
			submit() {
				if(this.form.items.length==0){
					this.$message.error('请至少设置一项会员等级');
					return false;
				}
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateVipGradeSet();
					} else {
						console.log('error submit!')
						return false;
					}
				})
			},
			updateVipGradeSet() {
				let temp = this.cloneObj(this.form);

				let id = temp.id;

				if (!id) id = '';

				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/vipgrade/vip_grade_set_update?id=" + id,
					temp).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getVipGradeList();
						});
					} else {

						this.messageCommon('错误', data.msg, 'error');
					}


				});
			},
			statusChange(val) {
				let status = val.status;
				if (status == 2) {
					status = 1;
				} else {
					status = 2
				}
				this.loading = true;
				this.httpPost({
					url: '/admin/vipgrade/change_status',
					data: {
						id: val.id,
						status: status
					}
				}).then((res) => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					}
					this.loading = false;
					this.getVipGradeList();
				})
			}

		},
		created() {
			this.getVipGradeList();
		}
	}
</script>

<style>
</style>
